export enum OtpPurpose {
  Register = 1,
  ResetPassword = 2
}
